<template>
  <!-- 个人-工种报价-包含材料列表 -->
  <div class="materialTable_page">
    <el-table
      :data="data"
      :header-cell-style="setColumnDataColor"
      :cell-style="setCellStyle"
      style="width: 100%"
      v-loading="loadingTrue"
    >
      <template slot="empty">
        <img src="@/static/img/cailiao.png" alt />
        <p class="noText" style="color: #000; fontsize: 16px">暂无数据</p>
      </template>
      <el-table-column
        align="left"
        prop="name"
        label="机械设备名称"
        show-overflow-tooltip
        width="250"
      ></el-table-column>
      <el-table-column
        align="left"
        prop="model"
        label="规格型号"
        show-overflow-tooltip
        width="250"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.model ? scope.row.model : "/" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="unit"
        label="计量单位"
        width="250"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        align="left"
        prop="quantity"
        label="设备数量"
        width="250"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.quantity ? scope.row.quantity : "/" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="材料图片"
        prop="url"
        width="156"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.url"
            fit="cover"
            style="width: 50px; height: 40px; margin:5px;"
            :src="scope.row.url"
            :preview-src-list="[scope.row.url]"
          ></el-image>
          <div slot="error" v-else>
            <span>/</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  setColumnDataColor,
  setCellStyle
} from '@/views/Home/components/style.js'
export default {
  data () {
    return {
      setColumnDataColor,
      setCellStyle
    }
  },
  props: {
    data: {
      type: Array
    },
    loadingTrue: {
      type: Boolean
    }
  },
  components: {},

  methods: {
    // 隐藏号码中间4位数
    starPhone (phoneNum) {
      let str = String(phoneNum)
      return str.substr(0, 3) + '****' + str.substr(7)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
/deep/.el-table th ,/deep/.el-table td{
  height: 44px !important;
  padding: 0 !important;
}
</style>
